<template>
    <div>
        <div class="org-tree-layout">
            <swb-popover-org-tree :showRealCom="true" :onlyShowRealCom="true" :prftFlag="false" :selectRealComId="selectRealComId" @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <swb-contract-search name="swb-contract-search" :contractType="contractType" :isFstParty="false" :tag="sndPartyFlag" @notity-syncRefresh="searchSyncRefresh" ref="swb_contract_search"></swb-contract-search>
        <div class="tab-container base small">
            <div class="tabs-nav">
                <ul class="head">
                    <li class="head-item" v-for="(text, value) in contractStateList" :class="{'current': value == checkStateValue}" @click="changeStatue(value)">
                        <span>{{text}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="simple-row">
            <div class="left">
                <button v-if="checkActionPerm('add')" @click="goRegisterContract();" class='swb-btn swb-btn-small'>
                    <span>新增合同</span>
                </button>
            </div>
            <div class="right">
                <span v-if="contractType != servcDlgt.value"><el-checkbox class="mr15" v-model="relevanceCallBid" @change="changeCheckBox">关联招投标</el-checkbox></span>
                <span v-if="contractType != servcDlgt.value"><el-checkbox class="mr15" v-model="relevanceReply" @change="changeCheckBox">关联询价单</el-checkbox></span>
                <span v-if="contractType != servcDlgt.value"><el-checkbox class="mr15" v-model="userCreate" @change="changeCheckBox">自己创建</el-checkbox></span>
            </div>
        </div>

        <div class="table-layout">
            <el-table :data="contractList" border style="width: 100%" :height="domHeight">
                <el-table-column prop="no" label="系统合同编号" width="150" align="left" fixed="left" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <a v-if="checkActionPerm('view')" class="swb-btn-link" @click="goRegisterContract(rows.row.id,'chakan')">{{rows.row.no}}</a>
                        <span v-else>{{rows.row.no}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="statusLabel" label="标签" width="150" align="center" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <a v-if="rows.row.offline" class="swb-tags swb-tags-outlined">线下</a>
                        <a v-if="rows.row.proxied" class="swb-tags swb-tags-outlined">代理</a>
                    </template>
                </el-table-column>
                <el-table-column prop="kindId" label="合同种类" width="100" align="center" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span v-if="rows.row.kindId == 0">标准合同</span>
                        <span v-if="rows.row.kindId == 1">框架合同</span>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="合同名称" width="140" align="left" show-overflow-tooltip></el-table-column>
<!--                <el-table-column prop="sndPartyHtBh" label="自用合同编号" width="140" align="left" show-overflow-tooltip></el-table-column>-->
                <el-table-column prop="accordHtBh" label="合同编号" width="140" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="fstPartyName" :label="merchant + '名称'" width="140" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="fstTaxPayType" label="买家纳税类型" width="100" align="center" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span>{{taxPayTypeMap[rows.row.fstTaxPayType]}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sndTaxPayType" label="卖家纳税类型" width="100" align="center" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span>{{taxPayTypeMap[rows.row.sndTaxPayType]}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="signDate" label="签署日期" align="center" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="contractType != servcDlgt.value" label="预计合同金额" align="right" width="120" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <div v-if="rows.row.kindId == 0">
                            <div v-if="checkActionPerm('view_total_price')">
                                <span v-if="rows.row.estmtAmount != null">{{((rows.row.estmtAmount).toFixed(2)).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}}元</span>
                                <span v-else>0.00元</span>
                            </div>
                            <div v-else>
                                <span>没有权限</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="dateEnd" label="结束时间" align="center" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="state" label="状态" width="130" align="center" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <el-tag v-if="rows.row.sndPartyConfirmed == false && !rows.row.confirmed && !rows.row.closed" type="danger" style="background-color: transparent; border: none" close-transition>
                            <span v-if="rows.row.sndPartyApplyState == 0 && rows.row.fstPartyAuditState == 0">未申请<br/>({{merchant}}未确认)</span>
                            <span v-if="rows.row.sndPartyApplyState == 0 && rows.row.fstPartyAuditState == 1">未申请<br/>({{merchant}}已确认)</span>
                            <span v-if="rows.row.sndPartyApplyState == 1 && rows.row.fstPartyAuditState == 0">待审核<br/>({{merchant}}未确认)</span>
                            <span v-if="rows.row.sndPartyApplyState == 1 && rows.row.fstPartyAuditState == 1">待审核<br/>({{merchant}}已确认)</span>
                            <span v-if="rows.row.sndPartyApplyState != 1 && rows.row.sndPartyAuditState == -1 && rows.row.fstPartyAuditState == 0">审核拒绝<br/>({{merchant}}未确认)</span>
                            <span v-if="rows.row.sndPartyApplyState != 1 && rows.row.sndPartyAuditState == -1 && rows.row.fstPartyAuditState == 1">审核拒绝<br/>({{merchant}}已确认)</span>
                        </el-tag>
                        <el-tag v-if="rows.row.sndPartyConfirmed == true && !rows.row.confirmed  && !rows.row.closed" type="success" style="background-color: transparent; border: none" close-transition>
                            已确认<br/>
                            <span v-if="rows.row.fstPartyConfirmed == false">({{merchant}}未确认)</span>
                        </el-tag>
                        <el-tag v-if="rows.row.confirmed && rows.row.curValid && !rows.row.fullfilled && !rows.row.closed && rows.row.lockMode != 1 && !rows.row.terminated" type="success" style="background-color: transparent; border: none" close-transition>
                            <span v-if="rows.row.lockMode == -1">履约中<br/><span class="ml5 font-red">(已变更)</span></span>
                            <span v-else-if="rows.row.lockMode == 0">履约中</span>
                        </el-tag>
                        <el-tag v-if="rows.row.terminated && !rows.row.closed" type="danger" style="background-color: transparent; border: none" close-transition>
                            <span>异常终止</span>
                        </el-tag>
                        <el-tag v-if="rows.row.fullfilled && rows.row.curValid && !rows.row.checked  && !rows.row.closed && rows.row.lockMode != 1" type="success" style="background-color: transparent; border: none" close-transition>
                            <span>验收中</span>
                        </el-tag>
                        <el-tag v-if="rows.row.checked && rows.row.curValid  && !rows.row.closed" type="success" style="background-color: transparent; border: none" close-transition>
                            <span>已验收</span>
                        </el-tag>
                        <el-tag v-if="rows.row.closed" type="danger" style="background-color: transparent; border: none" close-transition>
                            <span>已关闭</span>
                        </el-tag>
                        <el-tag v-if="!rows.row.closed && rows.row.lockMode == 1" type="danger" style="background-color: transparent; border: none" close-transition>
                            <span>已锁定</span>
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="dateEndDue" label="合同到期" align="left" width="100" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span>{{ rows.row.dateEndDue ? '已到期' : '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="phaseName" label="计划阶段" align="left" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="sndPartyFlag" label="自用合同标签" align="left" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="300" fixed="right">
                    <template slot-scope="rows">
                        <div>
                            <a class="swb-btn-link" v-if="checkActionPerm('modify') && rows.row.sndPartyConfirmed == false && rows.row.sndPartyApplyState != 1" @click="goRegisterContract(rows.row.id,'edit')">编辑</a>
                            <!--<a class="swb-btn-link" v-if="checkActionPerm('delete') && rows.row.deleted == true && rows.row.closed == true" @click="deleteContractById(rows.row.id)">删除</a>-->
                            <a class="swb-btn-link" v-if="checkActionPerm('apply') && rows.row.sndPartyApplyState != 1 && rows.row.curValid == false && rows.row.sndPartyConfirmed == false" @click="applyAuditDlg(rows.row)">申请审核</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('audit') && rows.row.sndPartyApplyState == 1 && rows.row.sndPartyAuditState != 1 && rows.row.sndPartyAuditorPostId == userInfo.scopeEntity.postId && !rows.row.closed" @click="confirmContract(rows.row)">审核确认</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('invalidate') && !rows.row.confirmed && !rows.row.checked && rows.row.sndPartyConfirmed == false" @click="cancelledGoodsContract(rows.row)">作废</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('change') && rows.row.curValid == true && !rows.row.checked && rows.row.lockMode == 0 && !rows.row.offline && !rows.row.terminated" @click="goRegisterContract(rows.row.id,'change')">变更</a>
                            <!--<a class="swb-btn-link" v-if="checkActionPerm('order_goods') && contractType== integPurch.value && rows.row.curValid == true && !rows.row.fullfilled && !rows.row.checked && rows.row.lockMode == 0 && !rows.row.offline && !rows.row.terminated" @click="toSaveGoodsOrder(rows.row)">订商品</a>-->
                            <a class="swb-btn-link" v-if="checkActionPerm('order_servc') && rows.row.curValid == true && !rows.row.fullfilled && !rows.row.checked && rows.row.lockMode == 0 && !rows.row.offline && !rows.row.terminated" @click="toSaveServcOrder(rows.row.id)">订服务</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_goods_order') && contractType== integPurch.value && (rows.row.curValid == true || rows.row.closed) && !rows.row.offline && !rows.row.terminated" @click="toGoodsOrderList(rows.row.id)">查看商品订单</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_servc_order') && (rows.row.curValid == true || rows.row.closed) && !rows.row.offline && !rows.row.terminated" @click="toServcOrderList(rows.row.id)">查看服务订单</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('apply_fulfill_finish') && rows.row.curValid == true  && !rows.row.fullfilled && !rows.row.checked && !rows.row.locked && rows.row.fulfillApplyState != 1 && rows.row.fulfillAuditState != 1 && !rows.row.terminated" @click="tofulfillApply(rows.row)">履约完成申请</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('apply_check') && rows.row.curValid == true  && rows.row.fullfilled && !rows.row.checked && !rows.row.locked && rows.row.checkApplyState != 1 && rows.row.checkAuditState != 1 && !rows.row.terminated" @click="toCheckApply(rows.row)">申请验收</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('search_tag')" @click="searchTag(rows.row.sndPartyFlag)">搜索标签</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('set_tag')" @click="setSndPartyFlag(rows.row)">设置标签</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('add_biz_rel') && (contractType == servcPurch.value || contractType == integPurch.value)" @click="addQualifiedMerchant(rows.row.fstPartyId, rows.row.fstPartyType)">加入客户管理</a>
                            <!--<a class="swb-btn-link" v-if="checkActionPerm('sit_msg_mgmt')" @click="openSendMsgDlg(rows.row)">站内信</a>-->
                            <a class="swb-btn-link" v-if="checkActionPerm('view_log')" @click="showLogDlg(rows.row.no)">查看日志</a>
                            <a class="swb-btn-link" @click="openSendMsgDlg(rows.row)">站内信</a>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-layout">
            <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import appConf from '../../app.conf';
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../../src/app.conf'
    import { openContractLogListDlg } from './dialog'
    import { showComActionPostSelectDlg } from '../merchant/showSelectDlg';
    import { checkUserActionPerm } from '../index'
    import { openSendMsgListDlg } from '../msg/dialog'
    import { showMsgDlg } from '../merchant/showSelectDlg'
    import { voucherType } from '../../../resc/app/js/voucherType';

    import servicerApi from '../../api/servicer'
    import userApi from '../../api/user'
    import contractApi from '../../api/contract'
    import merchtQualiApi from '../../api/merchtQuali'
    import merchtAllApi from '../../api/merchtAll'
    import merchtComnApi from '../../api/merchtComn'

    import SwbContractSearch from './ContractSearch';
    Vue.regist(SwbContractSearch);

    import SwbServcPurchContractList from './ServcPurchContractList';
    Routes.add(SwbServcPurchContractList);
    import SwbIntegPurchContractList from './IntegPurchContractList';
    Routes.add(SwbIntegPurchContractList);
    import SwbServcDlgtContractList from './ServcDlgtContractList';
    Routes.add(SwbServcDlgtContractList);
    import SwbGoodsOrderList from '../order/GoodsOrderList';
    Routes.add(SwbGoodsOrderList);
    import SwbContractServcOrderList from '../servcOrder/ContractServcOrderList';
    Routes.add(SwbContractServcOrderList);
    import SwbProxyGoodsOrder from '../order/ProxyGoodsOrder';
    Routes.add(SwbProxyGoodsOrder);
    import SwbServcOrderCreate from '../servcOrder/ServcOrderCreate';
    Routes.add(SwbServcOrderCreate);

    import SwbPopoverOrgTree from '../orgStruct/PopoverOrgTree';
    Vue.regist(SwbPopoverOrgTree);

    export default {
        name: 'swb-comn-seller-contract-list',
        desc: '合同列表（乙方）',
        props: ['contractType', 'merchant', 'path', 'thisPath'],
        data: function () {
            return {
                domHeight: 'auto',
                //
                contractList: [],
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                sndPartyHtBh: null,
                fstPartyName: null,
                selectTab: true,
                title: null,
                dateStart: null,
                dateEnd: null,
                contractStateList: [],
                checkStateValue: 0,
                no: null,
                sndPartyFlag: null,

                servcPurch: {},
                integPurch: {},
                servcDlgt: {},

                userInfo: {},
                searchShow: false,
                relevanceCallBid: false,
                relevanceReply: false,
                userCreate: false,
                callBidDocSource: {},
                priceInqrySource: {},
                estmtAmountBefore: null,
                estmtAmountAfter: null,
                servicerStaffList: [],
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                taxPayTypeMap: getEnumMap("taxPayType", "value2text"),
                selectRealComId: null,
            }
        },
        created: function () {
            let self = this;
            self.pageSize = self.pageSizes.first();

            let no = this.$route.query.no || null;
            if(!Utils.isNoB(no)) {
                this.no = no;
                this.queryModel.filterItems.no = no;
            }
            self.getContractState();
            self.getStaffByComId();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass("overflow-hidden");
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('.table-layout'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.domHeight = height;
            });
            domSizeWatcher.setVtEls(thisEl.find('.org-tree-layout, [name = "swb-contract-search"], .tab-container, .simple-row, .pagination-layout'));
            domSizeWatcher.start(500);
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            searchSyncRefresh: function (queryModel) {
                this.queryModel = queryModel;
                //
                this.pageNumber = 1;
                this.getContractList(this.checkStateValue);
            },
            checkActionPerm: function (action) {
                return checkUserActionPerm(this.thisPath, action, null);
            },
            getStaffByComId: function () {
                let self = this;
                let postData = {};
                servicerApi.getServicerStaffListByComId(postData, function (result) {
                    if(result.type === "info") {
                        self.servicerStaffList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            changeCheckBox: function () {
                this.getContractList(this.checkStateValue);
            },
            searchTag: function (tag) {
                this.sndPartyFlag = tag;
                this.searchShow = true;
                this.queryModel.filterItems.sndPartyFlag = tag;
                this.getContractList(this.checkStateValue);
            },
            showSearch: function (flag) {
                this.searchShow = flag;
            },
            getCurrentUserInfo: function () {
                let self = this;
                let postData = {};
                userApi.getUserInfoByContext(postData, function (result) {
                    if(result.type == "info") {
                        self.userInfo = result.data;
                        self.selectRealComId = result.data.scopeEntity.realComId;
                        //
                        self.getContractList();
                    }
                });
            },
            checkComCatChange: function (eventData) {
                this.selectRealComId = eventData.id;
                //
                this.getContractList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getContractList(this.checkStateValue);
            },
            getContractState: function () {
                this.contractStateList = getEnumMap('contractState', 'value2text');

                this.servcPurch = getEnumInfoWith("contractType", 'name', 'ServcPurch');
                this.integPurch = getEnumInfoWith("contractType", 'name', 'IntegPurch');
                this.servcDlgt = getEnumInfoWith("contractType", 'name', 'ServcDlgt');

                this.callBidDocSource = getEnumInfoWith("bizSrcFlag", 'name', 'BidDoc');
                this.priceInqrySource = getEnumInfoWith("bizSrcFlag", 'name', 'PriceInqry');

                this.getCurrentUserInfo();
            },
            changeStatue: function (value) {
                let self = this;
                self.checkStateValue = value;
                self.pageNumber = 1;
                self.getContractList(value);
            },
            getContractList: function (state) {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.realComId = self.selectRealComId || null;
                if(self.relevanceCallBid) {
                    filterItems.srcFlag = self.callBidDocSource.value;
                }
                if(self.relevanceReply) {
                    filterItems.srcFlag = self.priceInqrySource.value;
                }
                if(self.userCreate) {
                    filterItems.creatorId = self.userInfo.userId;
                }
                //
                filterItems.typeId = self.contractType;
                if(self.contractType == self.servcPurch.value) {
                    filterItems.sndPartyType = self.servcPurch.sndPartyType;
                } else if(self.contractType == self.integPurch.value) {
                    filterItems.sndPartyType = self.integPurch.sndPartyType;
                } else if(self.contractType == self.servcDlgt.value) {
                    filterItems.sndPartyType = self.servcDlgt.sndPartyType;
                }

                if(state == 1) {
                    filterItems.curValid = false;
                    filterItems.closed = false;
                } else if(state == 2) {
                    filterItems.curValid = true;
                    filterItems.confirmed = true;
                    filterItems.fullfilled = false;
                    filterItems.terminated = false;
                    filterItems.closed = false;
                } else if(state == 3) {
                    filterItems.curValid = true;
                    filterItems.fullfilled = true;
                    filterItems.checked = false;
                    filterItems.closed = false;
                } else if(state == 4) {
                    filterItems.curValid = true;
                    filterItems.checked = true;
                    filterItems.closed = false;
                } else if(state == -1) {
                    filterItems.curValid = false;
                    filterItems.closed = true;
                }
                //filterItems.sndPartyConfirmed = true;
                //filterItems.sndPartyModifierId = self.userInfo.userId;
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                let theLoad = MsgBox.loading("数据查询中.....");
                contractApi.getContractList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let data = result.data;
                        self.contractList = data.rows;
                        //结果应用
                        let pagination = data.pagination;
                        if(pagination != null) {
                            self.totalCount = pagination.totalCount;
                            self.pageNumber = pagination.pageNumber;
                            self.pageSize = pagination.pageSize;
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            goRegisterContract: function (contractId, operation) {
                let self = this;
                let postData = {};
                postData.merchantId = self.userInfo.scopeEntity.id;
                postData.merchantType = self.userInfo.scopeEntity.type;
                merchtQualiApi.existMerchtQualiTrade(postData, function (result) {
                    if(result.type == 'info') {
                        let existTrade = result.data;
                        if(existTrade) {
                            let query = {
                                parentPath: self.thisPath
                            };
                            if(contractId != null) {
                                query.contractId = contractId;
                                query.operate = operation;
                            }
                            self.$router.push({
                                path: self.path,
                                query: query
                            });
                        } else {
                            MsgBox.warning("平台交易资质未认证，相关业务不能执行！");
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            deleteContractById: function (id) {
                let self = this;
                self.$confirm('确定要删除该信息吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let item = {};
                    item.id = id;
                    contractApi.deleteContract(item, function (result) {
                        if(result.type === "info") {
                            self.getContractList(self.checkStateValue);
                            MsgBox.success('删除成功!');
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            applyAuditDlg: function (item) {
                let self = this;
//                if(item.sndPartyHtBh == null) {
//                    MsgBox.warning('请编辑合同，填写合同编号');
//                    return;
//                }
                let dlgArgs = {};
                dlgArgs.rescUrl = this.thisPath;
                dlgArgs.action = 'audit';
                dlgArgs.useDesc = true;
                dlgArgs.initPostId = item.sndPartyAuditorPostId;
                dlgArgs.applyDesc = item.sndPartyApplyDesc;
                showComActionPostSelectDlg(dlgArgs, function (resultData) {
                    let postId = resultData.postId;
                    let applyDesc = resultData.applyDesc;
                    if(postId == null) {
                        MsgBox.warning("请选择审核人");
                        return false;
                    }
                    item.sndPartyAuditorPostId = postId;
                    item.sndPartyApplyDesc = applyDesc;
                    let theLoad = MsgBox.loading("申请审核中.....");
                    contractApi.applyContract(item, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            MsgBox.success('申请成功!');
                            self.getContractList(self.checkStateValue);
                        } else {
                            MsgBox.warning(result.message);
                            self.getContractList(self.checkStateValue);
                        }
                    });
                }, this);
            },
            confirmContract: function (item) {
                let self = this;
                self.$confirm('请先查看合同内容！是否审核确认此合同。', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theDlg = Vue.$showDialog({
                        title: '审核确认',
                        showCloseBtn: true,
                        width: 530,
                        height: 620,
                        template: '<div>' +
                        '<div class="form-row spacing">' +
                        '<div class="form-label">' +
                        '<label>&nbsp;</label>' +
                        '</div>' +
                        '<div class="form-value width-1-5x">' +
                        '<el-radio class="radio" v-model="auditState" :label=1>通过</el-radio>' +
                        '<el-radio class="radio" v-model="auditState" :label=-1>拒绝</el-radio>' +
                        '</div>' +
                        '</div>' +
                        '<div class="form-row spacing">' +
                        '<div class="form-label">' +
                        '<label>审核描述</label>' +
                        '</div>' +
                        '<div class="form-value width-1-5x">' +
                        '<el-input type="textarea" v-model="auditDesc"></el-input>' +
                        '</div>' +
                        '</div>' +
                        '<div v-if = "auditState == 1">' +
                        '<div class="form-row spacing">' +
                        '<div class="form-label">' +
                        '<label>是否给对方发站内信</label>' +
                        '</div>' +
                        '<div class="form-value width-1-5x">' +
                        '<el-radio  class="radio" v-model="msgIsSend" :label=true>是</el-radio>' +
                        '<el-radio  class="radio" v-model="msgIsSend" :label=false>否</el-radio>' +
                        '</div>' +
                        '</div>' +
                        '<div v-if="msgIsSend" class="form-row spacing">' +
                        '<div class="form-label">' +
                        '<label>主题</label>' +
                        '</div>' +
                        '<div class="form-value width-1-5x">' +
                        '<el-input v-model="msgSubject"></el-input>' +
                        '</div>' +
                        '</div>' +
                        '<div v-if="msgIsSend" class="form-row spacing">' +
                        '<div class="form-label">' +
                        '<label>内容</label>' +
                        '</div>' +
                        '<div class="form-value width-1-5x">' +
                        '<el-input type="textarea" :autosize="{ minRows: 7, maxRows: 11 }" v-model="msgContent"></el-input>' +
                        '</div>' +
                        '</div>' +
                        '</div>' +
                        '</div>',
                        data: {
                            auditState: -1,
                            auditDesc: null,
                            msgIsSend: false,
                            msgSubject: null,
                            msgContent: null
                        },
                        methods: {},
                        okClicked: function () {
                            let selfDlg = this;
                            if(selfDlg.auditState == 1 && selfDlg.msgIsSend) {
                                if(selfDlg.msgSubject == null) {
                                    MsgBox.warning("请填写主题");
                                    return false;
                                }
                                if(selfDlg.msgContent == null) {
                                    MsgBox.warning("请填写内容");
                                    return false;
                                }
                                item.msgSubject = selfDlg.msgSubject;
                                item.msgContent = selfDlg.msgContent;
                                let hashUrl = "";
                                let data = {no: item.no};
                                if(self.contractType == self.servcPurch.value) {
                                    hashUrl = Utils.makeUrl(SwbServcPurchContractList.path, data);
                                }
                                else if(self.contractType == self.integPurch.value) {
                                    hashUrl = Utils.makeUrl(SwbIntegPurchContractList.path, data);
                                }
                                else if(self.contractType == self.servcDlgt.value) {
                                    hashUrl = Utils.makeUrl(SwbServcDlgtContractList.path, data);
                                }
                                item.msgUrl = hashUrl;
                            } else {
                                selfDlg.msgIsSend = false;
                            }
                            item.msgIsSend = selfDlg.msgIsSend;
                            item.sndPartyAuditState = selfDlg.auditState;
                            item.sndPartyAuditDesc = selfDlg.auditDesc;
                            let theLoad = MsgBox.loading("审核中.....");
                            contractApi.auditAndConfirmContract(item, function (result) {
                                theLoad.hide();
                                if(result.type === "info") {
                                    theDlg.close();
                                    MsgBox.success('审核成功!');
                                    self.getContractList(self.checkStateValue);
                                } else {
                                    Toast.show(result.message, 3000, 'warning');
                                    self.getContractList(self.checkStateValue);
                                    return false;
                                    // MsgBox.warning(result.message);
                                }
                            });
                            return false;
                        },
                        lifecycle: {
                            created: function () {
                                let selfDlg = this;
                            }
                        }
                    });
                }).catch(function () {
                });
            },
            cancelledGoodsContract: function (row) {
                let self = this;
                self.$confirm('确定要作废吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.contractId = row.id;
                    let theLoad = MsgBox.loading("作废中.....");
                    contractApi.doInvalidContract(postData, function (result) {
                        theLoad.hide();
                        if(result.type == "info") {
                            MsgBox.success("作废成功");
                            self.getContractList(self.checkStateValue);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            toGoodsOrderList: function (id) {
                this.$router.push({
                    path: SwbGoodsOrderList.path,
                    query: {
                        contractId: id,
                    }
                });
            },
            toServcOrderList: function (id) {
                this.$router.push({
                    path: SwbContractServcOrderList.path,
                    query: {
                        contractId: id,
                    }
                });
            },
            toSaveGoodsOrder: function (row) {
                let bizAreaIds = Utils.isTrue(row.bizAreaFlag) ? row.bizAreaIds : [];
                let bizAreaIdStr = bizAreaIds.join(",") || null;
                let bizFormIds = row.bizFormIds || [];
                let bizFormIdStr = bizFormIds.join(",") || null;
                this.$router.push({
                    path: SwbProxyGoodsOrder.path,
                    query: {
                        contractId: row.id,
                        contractNo: row.no,
                        bizAreaIdStr: bizAreaIdStr,
                        bizFormIdStr: bizFormIdStr
                    }
                });
            },
            toSaveServcOrder: function (id) {
                this.$router.push({
                    path: SwbServcOrderCreate.path,
                    query: {
                        contractId: id,
                    }
                });
            },
            tofulfillApply: function (row) {
                let self = this;
                Vue.$showDialog({
                    title: '履约完成申请',
                    showCloseBtn: true,
                    width: 500,
                    height: 300,
                    template: '<div>' +
                    '<div class="form-row spacing" style="height: 100px">' +
                    '<div class="form-label">' +
                    '<label>申请描述</label>' +
                    '</div>' +
                    '<div class="form-value width-1-5x">' +
                    '<el-input type="textarea" style="height: 100px" v-model="fulfillApplyDesc"></el-input>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        fulfillApplyDesc: null
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        row.fulfillApplyDesc = selfDlg.fulfillApplyDesc;
                        let theLoad = MsgBox.loading("申请中.....");
                        contractApi.applyContractFulfillFinished(row, function (result) {
                            theLoad.hide();
                            if(result.type === "info") {
                                self.getContractList(self.checkStateValue);
                                MsgBox.success('履约完成申请成功!');
                            } else {
                                MsgBox.warning(result.message);
                            }
                        })
                    },
                    lifecycle: {}
                });
            },
            toCheckApply: function (row) {
                let self = this;
                Vue.$showDialog({
                    title: '申请验收完成',
                    showCloseBtn: true,
                    width: 500,
                    height: 300,
                    template: '<div>' +
                    '<div class="form-row spacing" style="height: 100px">' +
                    '<div class="form-label">' +
                    '<label>申请描述</label>' +
                    '</div>' +
                    '<div class="form-value width-1-5x">' +
                    '<el-input type="textarea" style="height: 100px" v-model="checkApplyDesc"></el-input>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        checkApplyDesc: null
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        row.checkApplyDesc = selfDlg.checkApplyDesc;
                        let theLoad = MsgBox.loading("申请验收中.....");
                        contractApi.applyContractCheckFinished(row, function (result) {
                            theLoad.hide();
                            if(result.type === "info") {
                                self.getContractList(self.checkStateValue);
                                MsgBox.success('操作成功!');
                            } else {
                                MsgBox.warning(result.message);
                            }
                        })
                    },
                    lifecycle: {}
                });
            },
            setSndPartyFlag: function (row) {
                let self = this;
                Vue.$showDialog({
                    title: '设置标签',
                    showCloseBtn: true,
                    width: 530,
                    height: 300,
                    template: '<div>' +
                    '<div class="form-row spacing">' +
                    '<div class="form-label">' +
                    '<label>&nbsp;</label>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-row spacing">' +
                    '<div class="form-label">' +
                    '<label>标签</label>' +
                    '</div>' +
                    '<div class="form-value width-1-5x">' +
                    '<el-input type="text" v-model="sndPartyFlag"></el-input>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        sndPartyFlag: row.sndPartyFlag
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        row.sndPartyFlag = selfDlg.sndPartyFlag;
                        let theLoad = MsgBox.loading("保存中...");
                        contractApi.updateContract(row, function (result) {
                            if(result.type === "info") {
                                self.getContractList(self.checkStateValue);
                                MsgBox.success('设置成功!');
                            } else {
                                MsgBox.warning(result.message);
                            }
                            theLoad.hide();
                        });
                    },
                    lifecycle: {}
                });
            },
            // 加入合格商户
            addQualifiedMerchant: function (merchantId, merchantType) {
                // 为了使用原有的接口，设置数据
                let peerMerchantIds = [];
                peerMerchantIds.add(merchantId);
                //
                let postData = {};
                postData.bizRelIds = peerMerchantIds;
                postData.peerMerchantType = merchantType;
                merchtComnApi.saveMerchantBizRel(postData, function (result) {
                    if(result != null) {
                        if(result.type == 'info') {
                            MsgBox.success(result.message);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    }
                });
            },
            openSendMsgDlg: function (contract) {
                // openSendMsgListDlg(null, "voucher", "contract", contract.no, 'sndParty', contract.id);
                let receiverData = {};
                //
                receiverData.currentPostIds = [
                    contract.sndPartyConfirmerPostId
                ];
                receiverData.currentMerchtType = contract.sndPartyType; // getEnumInfoWith('merchantType', 'name', 'Retailer').value;
                receiverData.otherPostIds = [
                    contract.fstPartyConfirmerPostId
                ];
                receiverData.otherMerchtType = contract.fstPartyType;
                receiverData.voucherChildType = this.contractType;
                //
                // console.log('rrrrrrrrrrrrr');
                // console.log(receiverData);
                //
                showMsgDlg(true, 'voucher', voucherType.CONTRACT, contract.no, receiverData);
            },
            // 查看合同日志
            showLogDlg: function (contractNo) {
                //
                openContractLogListDlg(contractNo);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/contract/ComnSellerContractList.vue